var React = require('react');
var css = require('./module.scss');

var Input = React.createClass({
    getInitialState: function() {
        return {
            value: this.props.value,
            total: this.props.total,
            left: this.props.total - this.props.value.length
        };
    },

    componentWillReceiveProps: function(nextProps) {
        nextProps.value=nextProps.value||'';
        this.setState({
            value: nextProps.value,
            left: nextProps.total - nextProps.value.length
        });
    },

    getTarget: function() {
        return this.refs[this.props.name];
    },

    getValue: function() {
        return this.getTarget().value;
    },

    onChange: function(e) {
        let value = e.target.value;
        let left = this.state.total - value.length;
        if (left < 0) {
            return;
        }
        this.setState({ left: left,value : value });
        this.props.onChange && this.props.onChange(e);
    },

    render: function() {
        let cls = ['fp-textarea-control'];
        if (this.props.className) {
            cls.push(this.props.className);
        }
        return <div className='fp-textarea-wrap' style={this.props.style}>
            <textarea
                className={cls.join(' ')}
                ref={this.props.name}
                id={this.props.name}
                name={this.props.name}
                disabled={this.props.disabled}
                readonly={this.props.readonly}
                onFocus={this.props.onFocus}
                onBlur={this.props.onBlur}
                onKeyDown={this.props.onKeyDown}
                onKeyPress={this.props.onKeyPress}
                onInput={this.props.onInput}
                onKeyUp={this.props.onKeyUp}
                onChange={this.onChange.bind(this)}
                onClick={this.props.onClick}
                placeholder={this.props.placeholder}
                defaultValue={this.props.value}
                autoComplete={this.props.autoComplete}
                value={this.state.value}
                rows={this.props.rows}
            />
            {
                (this.state.total && !this.props.disabled) ?
                    <span className="fp-textarea-tips">还可输入{this.state.left}个字</span>
                    : null
            }
        </div>;
    }

});

module.exports = Input;



// WEBPACK FOOTER //
// ./component/textarea/index.js